/**
 * Blends a given hex color with white
 * @param colorHex - The hex color to blend (e.g., "#FF0000")
 * @param intensity - The intensity of white in the blend (0-1).
 *                   - intensity = 1 means 100% white (completely white)
 *                   - intensity = 0 means 100% original color
 *                   - Default 0.75 means 75% white, 25% original color
 * @returns RGB color string (e.g., "rgb(255, 128, 128)")
 */
export const blendWithWhite = (colorHex: string, intensity: number = 0.75): string => {
  const hex = colorHex.replace("#", "");

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const blendedR = Math.round(255 * intensity + r * (1 - intensity));
  const blendedG = Math.round(255 * intensity + g * (1 - intensity));
  const blendedB = Math.round(255 * intensity + b * (1 - intensity));

  return `rgb(${blendedR}, ${blendedG}, ${blendedB})`;
};
